import { Component, inject, input } from '@angular/core';
import { QuestionFacade } from '../../../facade/question.facade';
import { ClientType } from '../../../service/type-detector.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  imports: [TranslatePipe],
})
export class ContactComponent {
  private readonly questionFacade = inject(QuestionFacade);

  readonly type = input<ClientType>(undefined);
  readonly Type = ClientType;
  onPhoneClick(): void {
    this.questionFacade.onPhoneClicked();
  }
}
